"use strict";
// Inspiration for converters taken from https://github.com/rdesmartin/quill-delta-markdown
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToMarkdown = void 0;
var to_markdown_1 = require("./to-markdown");
Object.defineProperty(exports, "ToMarkdown", { enumerable: true, get: function () { return to_markdown_1.ToMarkdown; } });
